import "isomorphic-fetch";
import { get } from "@churchofjesuschrist/universal-env";

const { APP_URL } = get();

export const exchangeRefreshToken = () =>
    fetch(`${APP_URL}/login/refresh`).then((res) => res.json());
